import React from 'react';

const HeroSection = () => {
  return (
    <section style={{
      position: 'relative',
      height: 'clamp(480px, 65vh, 700px)',
      overflow: 'hidden',
      background: '#050A12'
    }}>
      {/* Background image */}
      <img
        src="https://img.rocket.new/generatedImages/rocket_gen_img_152b04ea4-1772191888101.png"
        alt="Aerial view of Norwegian mountain peaks with winding roads through dramatic fjord landscape at golden hour"
        style={{
          position: 'absolute',
          inset: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          objectPosition: 'center 35%',
          filter: 'brightness(0.35) contrast(1.15) saturate(0.65)'
        }} />
      

      {/* Gradient overlays */}
      <div style={{
        position: 'absolute', inset: 0,
        background: 'linear-gradient(to bottom, rgba(5,10,18,0.3) 0%, rgba(5,10,18,0.85) 100%)'
      }} />
      <div style={{
        position: 'absolute', inset: 0,
        background: 'linear-gradient(135deg, rgba(59,111,212,0.12) 0%, transparent 60%)'
      }} />

      {/* Diagonal accent line */}
      <div style={{
        position: 'absolute', top: 0, left: '35%', width: '1px',
        height: '100%', background: 'rgba(232,99,10,0.15)',
        transform: 'rotate(6deg)', transformOrigin: 'top center',
        pointerEvents: 'none'
      }} />

      {/* Large background number */}
      <div style={{
        position: 'absolute', top: '-20px', right: '-10px',
        fontFamily: 'Impact, Arial Black, sans-serif',
        fontSize: 'clamp(200px, 30vw, 380px)',
        fontWeight: 900, color: 'rgba(59,111,212,0.05)',
        lineHeight: 1, userSelect: 'none', pointerEvents: 'none',
        letterSpacing: '-0.05em'
      }}>✓</div>

      {/* Content */}
      <div style={{
        position: 'absolute', inset: 0,
        display: 'flex', alignItems: 'center',
        padding: '0 5%', maxWidth: '1400px', margin: '0 auto'
      }}>
        <div style={{ position: 'relative', zIndex: 2 }}>
          {/* Label */}
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '28px' }}>
            <div style={{ width: '40px', height: '1px', background: '#E8630A' }} />
            <span style={{
              fontFamily: 'JetBrains Mono, monospace', fontSize: '0.65rem',
              color: '#E8630A', letterSpacing: '0.25em', textTransform: 'uppercase'
            }}>BEKREFTELSE</span>
          </div>

          {/* Checkmark badge */}
          <div style={{
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
            width: '72px', height: '72px',
            border: '3px solid #3B6FD4',
            background: 'rgba(59,111,212,0.12)',
            marginBottom: '28px',
            transform: 'rotate(-3deg)'
          }}>
            <svg width="36" height="36" viewBox="0 0 24 24" fill="none" stroke="#3B6FD4" strokeWidth="2.5" strokeLinecap="square">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </div>

          {/* Main heading */}
          <div style={{ marginBottom: '8px' }}>
            <div style={{
              fontFamily: 'Impact, Arial Black, sans-serif',
              fontSize: 'clamp(48px, 8vw, 100px)',
              fontWeight: 900, color: '#EEF0F2',
              lineHeight: 0.88, letterSpacing: '-0.03em',
              textTransform: 'uppercase',
              transform: 'rotate(-1deg)',
              display: 'inline-block'
            }}>TAKK FOR AT</div>
          </div>
          <div style={{
            fontFamily: 'Georgia, serif',
            fontStyle: 'italic',
            fontSize: 'clamp(40px, 6.5vw, 84px)',
            fontWeight: 700, color: '#3B6FD4',
            lineHeight: 0.92, letterSpacing: '-0.02em',
            marginBottom: '24px'
          }}>du abonnerer!</div>

          <p style={{
            fontFamily: 'Georgia, serif', fontStyle: 'italic',
            fontSize: 'clamp(1rem, 1.5vw, 1.2rem)',
            color: 'rgba(238,240,242,0.6)',
            lineHeight: 1.65, maxWidth: '480px'
          }}>
            Velkommen til NordPass-fellesskapet. Vi er glade for å ha deg med.
          </p>
        </div>
      </div>
    </section>);

};

export default HeroSection;